/**
 * Scene component extracted from HoseScene
 */

class HoseSceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);

        const location = cleverapps.meta.getSelectedLocation();

        let currentStage = location.getStage() + location.getProgress() / HoseLocation.LEVELS_PER_LOCATION;
        if (location.isCompleted() && location.canMoveNext()) {
            currentStage -= 1;
        } else if (!location.canMoveNext()) {
            currentStage += 0.4;
        }

        this.pagingScroll = new PagingScroll(location.getTotalStages());
        this.pagingScroll.scrollToLevel(0, currentStage);

        this.sceneComponent.setStyling(this.getBackgroundStyles());
        this.sceneComponent.setBundles(this.listBundles());
    }

    onSceneLoaded() {
        if (Game.currentGame) {
            cleverapps.throwAsync("Game.currentGame not cleared");
        }

        const episodesView = new PagingScrollView(this.pagingScroll);
        episodesView.setLocalZOrder(-1);
        this.node.addChild(episodesView);
    }

    hasPlayButton() {
        return typeof PlayButtonView !== "undefined";
    }

    buildPlayButton() {
        this.playButton = new PlayButtonView();
        return this.playButton;
    }

    onReady() {
        if (this.playButton) {
            this.playButton.addFinger();
        }
    }

    getBackgroundStyles() {
        const location = cleverapps.meta.getSelectedLocation();
        const bundleName = location.getBackgroundBundle();
        if (bundleName) {
            return {
                bundle: bundleName,
                backgroundId: "background"
            };
        }
    }

    listBundles() {
        let res = [];

        this.pagingScroll.listVisiblePages().forEach((page) => {
            const bundleId = page.getResourcesBundleId();
            if (bundles[bundleId]) {
                res.push(bundleId);
            }

            if (page.isComingSoon()) {
                res.push("episode_coming_soon");
            }
        });

        const location = cleverapps.meta.getSelectedLocation();
        const backgroundBundle = location.getBackgroundBundle();
        if (backgroundBundle) {
            res.push(backgroundBundle);
        }

        if (cleverapps.config.rpg) {
            res = res.concat(["episodes_resources"]);
        }

        return res;
    }

    gotoNextStage(callback, toEpisode) {
        this.pagingScroll.gotoNextPage(callback, toEpisode);
    }
}

Prefab.registerComponent("HoseSceneComponent", HoseSceneComponent);
